import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgChartsModule } from 'ng2-charts';
import { PatchComplianceGaugeComponent } from './components/patch-compliance-gauge/patch-compliance-gauge.component';
import { PatchComplianceTrendViewComponent } from './components/patch-compliance-trend-view/patch-compliance-trend-view.component';

// ng2-charts@3 predates standalone-directive support — BaseChartDirective only works
// declared inside an NgModule. These chart components must live here instead of being
// standalone like their siblings; PatchManagementComponent (standalone) imports this
// module directly to use them, same bridge pattern Angular supports for any standalone
// component consuming NgModule-declared components.
@NgModule({
  imports: [CommonModule, NgChartsModule, MatIconModule],
  declarations: [PatchComplianceGaugeComponent, PatchComplianceTrendViewComponent],
  exports: [PatchComplianceGaugeComponent, PatchComplianceTrendViewComponent],
})
export class PatchManagementChartsModule {}
